import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../../shared/shared.module';
import { NotesFormComponent } from './notes.component';
import { MatDialogModule } from '@angular/material/dialog';
import { VesselSaveButtonModule } from '../../vessel-save-button/vessel-save-button.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    MatDialogModule,
    VesselSaveButtonModule,
  ],
  declarations: [NotesFormComponent],
  entryComponents: [],
  exports: [NotesFormComponent],
  providers: [],
})
export class NotesFormModule {}
